<template>
  <b-card
    class="card-table"
    :class="{'has-link': tableUuid}"
    no-body
    @click="openCalcTable"
  >
    <b-card-body>
      <b-card-title>
        <font-awesome-icon :icon="['fas', 'calculator']" />
        {{ calculator.loanCalculatorName }}
      </b-card-title>
    </b-card-body>
    <b-card-body class="actions">
      <b-button
        variant="outline-success"
        size="sm"
        @click.stop="onCalculate"
      >
        <font-awesome-icon :icon="['fas', 'calculator']" />
        Calculate
      </b-button>
      <b-button
        variant="outline-primary"
        size="sm"
        @click.stop="onEdit"
      >
        <font-awesome-icon :icon="['fas', 'pencil-alt']" />
        Edit
      </b-button>
      <b-button
        v-b-tooltip.hover
        :disabled="isDeleteButtonDisabled"
        :title="deleteButtonTooltip"
        variant="outline-danger"
        size="sm"
        @click.stop="onDelete"
      >
        <font-awesome-icon :icon="['fas', 'trash']" />
        Delete
      </b-button>
    </b-card-body>
  </b-card>
</template>

<script>
import {createNamespacedHelpers} from 'vuex';
const {mapState: sidebarMapState} = createNamespacedHelpers('sidebar');
export default {
  name: 'CalculatorCard',
  props: {
    calculator: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      moduleUuid: '37f9e5ae-a0ab-425f-a8ea-b40f5eb79f7f',// this can be hardcoded, as it is system module, and created by ATLAS by script with fixed guid - if this is changed check BacMDM -> DTO -> System Modules
      tableUuid: null,
    };
  },
  computed: {
    ...sidebarMapState({
      foldersList: state => state.foldersList,
    }),
    isDeleteButtonDisabled() {
      return !!this.calculator.postedDate;
    },
    deleteButtonTooltip() {
      return this.isDeleteButtonDisabled
        ? 'Posted Date is set on this Loan Calculator. It cannot be deleted'
        : '';
    },
  },
  methods: {
    onDelete() {
      this.$emit('on-delete', this.calculator);
    },
    onEdit() {
      this.$emit('on-edit', this.calculator);
    },
    onCalculate() {
      this.$emit('on-calculate', this.calculator);
    },
    openCalcTable() {
      this.$router.push({
        name: 'dataManagementTableView',
        params: {
          tableId: this.tableUuid,
          moduleUuid: this.moduleUuid,
        },
        query: {
          moduleUuid: this.moduleUuid,
        },
      });
    },
  },
  mounted() {
    this.tableUuid = this.calculator.entityGuid;
  },
};
</script>

<style lang="scss" scoped>
@import "../../../core/scss/variables";

.card-table {
  min-height: 10rem;
  transition: 0.3s;
  border-radius: 0;

  &.has-link {
    cursor: pointer;

    &:hover {
      box-shadow: 0 0 0 2px $primary;
    }
  }
}

.actions {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  gap: 5px;
}
</style>